import { gameAction } from "_actions";
import { GameService } from "_services";
import React, { useEffect, useState } from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import ScrollableListView from "./ScrollableListView";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { de } from "date-fns/locale";
import PragmaticGameBox from "../GamerBoxes/PragmaticGameBox";
import DetroitBox from "../GamerBoxes/DetroitBox";

import { detroidGames } from "BaseServiceURLs";
import TimelessTechGameBox from "../GamerBoxes/TimelessTechGameBox";
import Footer from "../Home/Footer";
import MatGameBox from "../GamerBoxes/MatGameBox";
import InnovaBox from "../GamerBoxes/InnovaBox";
import { gamesGameTypes } from "BaseServiceURLs";
import { isGameLaunchAllowed } from "../gameLaunchAccess";

const Casino = (props) => {
  const { user, loggedIn, sports, games, UpdateGames, allGamesGameTypes } = props;
  const [loading, setLoading] = useState(false);
  const [currentProvider, setCurrentProvider] = useState("");
  const [FilterSearchValue, setFilterSearchValue] = useState("");

  let params = GetParams();

  function GetParams() {
    let params = useParams();
    return params;
  }
  useEffect(() => {
    getGames();
  }, []);

  useEffect(() => {
    if (games && params && params.ProviderId) {
      if (games.hasOwnProperty(params.ProviderId)) {
        setCurrentProvider(params.ProviderId);
      }
    } else {
      setCurrentProvider("pragmatic-casino");
    }
  }, [games, params.ProviderId]);

  const getGames = async () => {
    setLoading(true);
    await GameService.GET_GAMES()
      .then((res) => {
        setLoading(false);

        const newData = res.map((x) => {
          let y = x;
          if (x.middleware == "blas975") {
            y.CacheData = x.CacheData.reverse();
            return y;
          } else {
            return x;
          }
        });
        debugger;
        UpdateGames(newData);
      })
      .catch((err) => {
        debugger;

        setLoading(false);
      });
  };
  const pb = require("../../../assets/img/banners/games2.png");
  const pragmaticNotCasino = ["1301", "1320"]; //"1302",
  const iconixGames = ["crashgame"];

  const targetProviders = ["rocketman", "spribe", "aviatrix", "spaceman", "jetx"];
  const _games = games;

  const gaseaCategoryCodes = ['MINI', 'BINGO', 'FISH', 'INSTWIN', 'ARCADE'];
  const gaseaMINI = ["GASEA_Bgaming", "GASEA_Pragmatic_Play", "GASEA_Turbo_Games", "GASEA_CP_Games", "GASEA_Hacksaw", "GASEA_Tada", "GASEA_Spribe", "GASEA_Inout", "GASEA_Aviator_Studio", "GASEA_Lite", "GASEA_Alize_Mini", "GASEA_SmartSoft"];
  const gaseaBINGO = ["GASEA_Hacksaw", "GASEA_YellowBat", "GASEA_Microgaming"];
  const gaseaFISH = ["GASEA_Tada", "GASEA_YellowBat", "GASEA_JDB", "GASEA_Fachai", "GASEA_CQ9"];
  const gaseaINSTWIN = ["GASEA_Microgaming"];
  const gaseaARCADE = ["GASEA_Microgaming"];

  const gaseaGames = games
    ? Array.from(
      new Map(
        [
          ...gaseaMINI.flatMap(key => (games[key] ?? []).filter(item => item.categoryCode === "MINI")),
          ...gaseaBINGO.flatMap(key => (games[key] ?? []).filter(item => item.categoryCode === "BINGO")),
          ...gaseaFISH.flatMap(key => (games[key] ?? []).filter(item => item.categoryCode === "FISH")),
          ...gaseaINSTWIN.flatMap(key => (games[key] ?? []).filter(item => item.categoryCode === "INSTWIN")),
          ...gaseaARCADE.flatMap(key => (games[key] ?? []).filter(item => item.categoryCode === "ARCADE")),
        ].map(item => [item.id, item]) // id key
      ).values()
    )
    : [];

  const valuesToRemove = [25288, 25651, 25538, 30777];

  debugger;
  return (
    <Translation>
      {(t) => (
        <>
          <Helmet>
            <title>{t("TITLE_GAMES")}</title>
          </Helmet>
          <div>
            <ScrollableListView
              pb={pb}
              title={t("TITLE_GAMES")}
              provider={currentProvider}
              setProvider={setCurrentProvider}

              FilterSearchValue={FilterSearchValue}
              setFilterSearchValue={setFilterSearchValue}
              data={[...(_games ? _games.hasOwnProperty("aviatrix") ? _games["aviatrix"] : [] : []), ...(_games ? _games.hasOwnProperty("spaceman") ? _games["spaceman"] : [] : []), ...(_games ? _games.hasOwnProperty("jetx") ? _games["jetx"] : [] : []), ...allGamesGameTypes, ...(gaseaGames)].filter(x => {
                return isGameLaunchAllowed(x, x.vendor, x._midleware, props.permissions, loggedIn);
              }).filter(item => !valuesToRemove.includes(item.id))}
            >

              {
                /*
                  <>
           {
            _games && _games.hasOwnProperty("rocketman") && _games["rocketman"].filter((x) => x.enabled == 1).map((item, index) => (
              <InnovaBox key={index} isLive={false} index={index} item={item} />
            ))
           }
           
           {
            _games && _games.hasOwnProperty("spribe") && _games["spribe"].map((item, index) => (
              <InnovaBox key={index} isLive={false} index={index} item={item} />
            ))
           }
           
         
           
           </>
                
                */
              }

            </ScrollableListView>

          </div>
        </>
      )}
    </Translation>
  );
};
/*

                            .reverse()
                            .sort((a, b) =>
                              a.gameIdNumeric > b.gameIdNumeric ? -1 : 1
                            )
*/
const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, permissions, permissionsAll } = authentication;
  const { sports, games, allGames } = game;
  return {
    user,
    loggedIn,
    sports,
    games,
    allGames,
    allGamesGameTypes: allGames.filter(x => gamesGameTypes.some(y => y == x.type)),
    permissions,
    permissionsAll,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateGames: (data) => dispatch(gameAction.UpdateGamesData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Casino);
